import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "bg"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = ["src"];
const _hoisted_4 = ["src"];
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  id: "bdmap",
  class: "bdmap",
  ref: "bdmap"
};
const _hoisted_7 = {
  class: "areaTitle"
};
const _hoisted_8 = {
  class: "titlewrap"
};
const _hoisted_9 = {
  class: "data-container"
};
const _hoisted_10 = {
  class: "titlewrap"
};
const _hoisted_11 = {
  class: "dataBox"
};
const _hoisted_12 = {
  class: "datainnerbox"
};
const _hoisted_13 = {
  class: "title"
};
const _hoisted_14 = {
  class: "navwrap"
};
const _hoisted_15 = {
  class: "typewrap clearfix"
};
const _hoisted_16 = {
  class: "li0"
};
const _hoisted_17 = ["onClick"];
const _hoisted_18 = {
  class: "typewrap clearfix"
};
const _hoisted_19 = {
  class: "li0"
};
const _hoisted_20 = ["onClick"];
const _hoisted_21 = {
  class: "typewrap clearfix style2"
};
const _hoisted_22 = {
  class: "li0"
};
const _hoisted_23 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_mapv2assembly = _resolveComponent("mapv2assembly");
  const _component_typev2 = _resolveComponent("typev2");
  const _component_mappopupv2 = _resolveComponent("mappopupv2");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["mapContainer", {
      'isMobile': $props.isMobile
    }]),
    ref: "mapContainer",
    style: _normalizeStyle($data.mainStyle)
  }, [_createElementVNode("div", {
    class: _normalizeClass(`formUserId${$data.formUserId}`),
    style: {
      "width": "100%",
      "height": "100%",
      "position": "relative"
    }
  }, [_withDirectives(_createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
    src: $data.mapelem.bg
  }, null, 8, _hoisted_2)], 512), [[_vShow, $data.mapelem.bg !== '']]), _withDirectives(_createElementVNode("div", {
    class: "logo",
    style: _normalizeStyle($data.modulestyle.logo)
  }, [_createElementVNode("img", {
    src: $data.mapelem.logo
  }, null, 8, _hoisted_3)], 4), [[_vShow, $data.mapelem.logo !== '']]), _withDirectives(_createElementVNode("div", {
    class: "pickey",
    style: _normalizeStyle($data.modulestyle.pickey)
  }, [_createElementVNode("img", {
    src: $data.mapelem.pickey
  }, null, 8, _hoisted_4)], 4), [[_vShow, $data.mapelem.pickey !== '']]), $data.loadingmap ? (_openBlock(), _createBlock(_component_mapv2assembly, {
    key: 0,
    ref: "mapv2assembly",
    id: $props.id,
    showgdtilelayer: $data.mapLayers.tiles,
    showgeojsonlayer: $data.mapLayers.json,
    showstaticlayer: $data.mapLayers.static,
    staticimage: $data.mapLayers.staticimage,
    drawelement: $data.mapLayers.drawelement,
    geojson: $data.mapLayers.geojson,
    mapstyle: $data.mapstyle,
    adcode: $data.mapview.adcode,
    zoom: $data.mapview.zoom,
    minZoom: $data.mapview.minZoom,
    maxZoom: $data.mapview.maxZoom,
    extent: $data.mapview.extent,
    center: $data.mapview.center,
    scale: $data.mapview.scale,
    rotate: $data.mapview.rotate,
    translate: $data.mapview.translate,
    streetcode: $data.mapstreetcode,
    pointlist: $data.pointList,
    culturallist: $data.mapculturalList,
    isMobile: $data.isMobileflag,
    onSingleclick: $options.singleclick,
    onMarkerclick: $options.markerclick,
    onMarkermoveend: $options.markermoveend
  }, null, 8, ["id", "showgdtilelayer", "showgeojsonlayer", "showstaticlayer", "staticimage", "drawelement", "geojson", "mapstyle", "adcode", "zoom", "minZoom", "maxZoom", "extent", "center", "scale", "rotate", "translate", "streetcode", "pointlist", "culturallist", "isMobile", "onSingleclick", "onMarkerclick", "onMarkermoveend"])) : _createCommentVNode("", true), _createVNode(_component_typev2, {
    modeltype: $data.modeltype,
    typeshowflag: $data.form.showtype,
    typelist: $data.typeList,
    typebtnstyle: $data.typebtn,
    posstyle: $data.modulestyle.type,
    onTypeselect: $options.typeselect
  }, null, 8, ["modeltype", "typeshowflag", "typelist", "typebtnstyle", "posstyle", "onTypeselect"]), _createVNode(_component_mappopupv2, {
    detail: $data.pointdetail,
    popshowflag: $data.popshowflag,
    modeltype: $data.popmodeltype,
    isMobile: $data.isMobileflag,
    onCloseHandle: $options.closeHandle
  }, null, 8, ["detail", "popshowflag", "modeltype", "isMobile", "onCloseHandle"]), _withDirectives(_createElementVNode("div", {
    class: "golist",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.golist && $options.golist(...args))
  }, [_createElementVNode("img", {
    src: $data.mapelem.golist,
    alt: ""
  }, null, 8, _hoisted_5)], 512), [[_vShow, $data.showgolist]]), _createElementVNode("div", _hoisted_6, null, 512), _createElementVNode("div", _hoisted_7, [_cache[4] || (_cache[4] = _createElementVNode("span", null, "渭南市", -1)), _withDirectives(_createElementVNode("i", null, ">", 512), [[_vShow, $data.culturalarea !== '']]), _withDirectives(_createElementVNode("span", {
    class: "sp2"
  }, _toDisplayString($data.culturalarea), 513), [[_vShow, $data.culturalarea !== '']])]), _withDirectives(_createElementVNode("ul", _hoisted_8, [_createElementVNode("li", null, [_cache[5] || (_cache[5] = _createTextVNode("项目总量：")), _createElementVNode("span", null, _toDisplayString($data.culturalprojectSum), 1)]), _createElementVNode("li", null, [_cache[6] || (_cache[6] = _createTextVNode("传承人总量：")), _createElementVNode("span", null, _toDisplayString($data.culturalpersonSum), 1)])], 512), [[_vShow, $data.isMobileflag]]), _createElementVNode("div", _hoisted_9, [_withDirectives(_createElementVNode("ul", _hoisted_10, [_createElementVNode("li", null, [_cache[7] || (_cache[7] = _createTextVNode("项目总量：")), _createElementVNode("span", null, _toDisplayString($data.culturalprojectSum), 1)]), _createElementVNode("li", null, [_cache[8] || (_cache[8] = _createTextVNode("传承人总量：")), _createElementVNode("span", null, _toDisplayString($data.culturalpersonSum), 1)])], 512), [[_vShow, !$data.isMobileflag]]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("h3", _hoisted_13, _toDisplayString($data.culturalarea ? $data.culturalarea : '渭南市'), 1), _createElementVNode("ul", _hoisted_14, [_createElementVNode("li", {
    class: _normalizeClass({
      'active': $data.typeUlindex === 0
    }),
    onClick: _cache[1] || (_cache[1] = $event => $data.typeUlindex = 0)
  }, "非遗项目", 2), _createElementVNode("li", {
    class: _normalizeClass({
      'active': $data.typeUlindex === 1
    }),
    onClick: _cache[2] || (_cache[2] = $event => $data.typeUlindex = 1)
  }, "非遗传承人", 2), _createElementVNode("li", {
    class: _normalizeClass({
      'active': $data.typeUlindex === 2
    }),
    onClick: _cache[3] || (_cache[3] = $event => $data.typeUlindex = 2)
  }, "非遗工坊", 2)]), _withDirectives(_createElementVNode("ul", _hoisted_15, [_createElementVNode("li", _hoisted_16, [_createElementVNode("div", null, [_createElementVNode("span", null, _toDisplayString($data.culturalprojectDatalen), 1), _cache[9] || (_cache[9] = _createElementVNode("p", null, "总计（项）", -1))])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.culturalprojectData, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      class: _normalizeClass(`li${index + 1}`),
      key: index,
      onClick: $event => $options.openCategory(item.title)
    }, [_createElementVNode("div", null, [_createElementVNode("span", null, _toDisplayString($options.getValue(item.sum)), 1), _createElementVNode("p", null, _toDisplayString(item.title), 1)])], 10, _hoisted_17);
  }), 128))], 512), [[_vShow, $data.typeUlindex === 0]]), _withDirectives(_createElementVNode("ul", _hoisted_18, [_createElementVNode("li", _hoisted_19, [_createElementVNode("div", null, [_createElementVNode("span", null, _toDisplayString($data.culturalpersoncategorylen), 1), _cache[10] || (_cache[10] = _createElementVNode("p", null, "总计（项）", -1))])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.culturalpersonData, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      class: _normalizeClass(`li${index + 1}`),
      key: index,
      onClick: $event => $options.openCategory(item.title)
    }, [_createElementVNode("div", null, [_createElementVNode("span", null, _toDisplayString($options.getValue(item.sum)), 1), _createElementVNode("p", null, _toDisplayString(item.title), 1)])], 10, _hoisted_20);
  }), 128))], 512), [[_vShow, $data.typeUlindex === 1]]), _withDirectives(_createElementVNode("ul", _hoisted_21, [_createElementVNode("li", _hoisted_22, [_createElementVNode("div", null, [_createElementVNode("span", null, _toDisplayString($data.culturalworkshoplevellen), 1), _cache[11] || (_cache[11] = _createElementVNode("p", null, "总计（项）", -1))])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.culturalworkshoplevel, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      class: _normalizeClass(`li${index + 1}`),
      key: index,
      onClick: $event => $options.openCategory(item.title)
    }, [_createElementVNode("div", null, [_createElementVNode("span", null, _toDisplayString($options.getValue(item.sum)), 1), _createElementVNode("p", null, _toDisplayString(item.title), 1)])], 10, _hoisted_23);
  }), 128))], 512), [[_vShow, $data.typeUlindex === 2]])])])])], 2)], 6);
}